module.exports = __webpack_public_path__ + "img/dianhuagoutong.d58dcac0.png";